import { connect } from "react-redux";
import HomeAdvertisingBanner from "app/pages/Home/HomeAdvertisingBanner/HomeAdvertisingBanner";
import {
	getAdvertisingHomeBlockAd,
	getAdvertisingHomeBlockStatus,
} from "app/reducers/advertisingSelector";

const mapStateToProps = state => ({
	ad: getAdvertisingHomeBlockAd(state),
	status: getAdvertisingHomeBlockStatus(state),
});

export default connect(mapStateToProps)(HomeAdvertisingBanner);
